const ApmcP1 = ["apmc", "copyOfMarketCommitteEstDet", "certOfMarketCommitteCategory", "purposeOfAssistance", "estimateProjectCost","percentOfProjCostEligible", "planEstimateByApprovedPE", "isExistingConstructionOnProjSite", "toolsEquipQuotations", "estimateCertifiedByGovtEngineer"]

const ApmcP2 = ["permissionFromAuthority", "insuranceUndertakingPostConstruction", "auditUndertakingAfterAssistance", "schemeConditionsUndertaking","jointAccountAssistanceUndertaking", "noPriorAssistanceUndertaking","registerMaintenanceUndertaking","repaymentOnViolationUndertaking", "constructionCompletionCertificate", "noOutstandingDuesUndertaking", "constructionProcurementETendering", "goodsProcurementETendering", "guaranteeAssistance"]

const Apmcp3 = ["isLandOwnedByMarketingCommitee", "hasAssistanceApproved", "isMarktingCommitteeLocatedInGeneral", "isMarktingCommFinanciallyCapableOfExpense", "incExpenditureForLast3Yrs", "auditIncExpenditureForLast3Yrs", "existingFarmerFacilities", "marketCessIncome5YrsLast"]

const FakeAPIJSON = [{
  "applicationId": "1001755580549916",
  "status": "resubmission",
  "appStatusLevel": "pendingAtApmcResubmission",
  "applicationType": "scheme",
  "schemeId": 23,
  "rejectedFieldName": [
    {
      "annexureType": "annexureOne",
      "key": "certOfMarketCommitteCategory",
      "comment": "comment for Field 1"
    },
    {
      "annexureType": "annexureOne",
      "key": "estimateProjectCost",
      "comment": "Priority Done"
    },
    {
      "annexureType": "annexureOne",
      "key": "planEstimateByApprovedPE",
      "comment": "Comment Verified"
    },
    {
      "annexureType": "annexureOne",
      "key": "toolsEquipQuotations",
      "comment": "Data Enhanced"
    }
  ]
}]



const DistP1 = ["apmc", "copyOfMarketCommitteEstDet", "certOfMarketCommitteCategory", "purposeOfAssistance", "estimateProjectCost","percentOfProjCostEligible", "isExistingConstructionOnProjSite","planEstimateByApprovedPE","estimatePlanConstruction", "toolsEquipQuotations", "estimateCertifiedByGovtEngineer"]
const DistP2 = ["permissionFromAuthority", "insuranceUndertakingPostConstruction", "auditUndertakingAfterAssistance", "schemeConditionsUndertaking","jointAccountAssistanceUndertaking", "noPriorAssistanceUndertaking","registerMaintenanceUndertaking","repaymentOnViolationUndertaking", "constructionCompletionCertificate", "noOutstandingDuesUndertaking", "constructionProcurementETendering", "goodsProcurementETendering", "guaranteeAssistance"]
const DistP3 = ["isLandOwnedByMarketingCommitee", "hasAssistanceApproved", "isMarktingCommitteeLocatedInGeneral", "isMarktingCommFinanciallyCapableOfExpense", "incExpenditureForLast3Yrs", "auditIncExpenditureForLast3Yrs", "existingFarmerFacilities", "marketCessIncome5YrsLast", "availingAssistance", "sanctionAssistance","designationRepresentative", "nameRepres"]
export const formFieldDataP1 = [
  {
    "fieldNo": "01.",
    "fieldVal": "ખેતીવાડી ઉત્પન્ન બજાર સમિતિનું નામ અને સરનામું.(Name and address of the Agricultural Produce Market Committee).",
    "fieldName":"apmc",
    "fieldLabel":"Name and address of the Agricultural Produce Market Committee",
    "responseType": "select",
    "response": [
      { "responseType": "select", roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"], "fieldName": "apmc", "responseVal": "district", "responseName": "District" },
      { "responseType": "select", roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],  "fieldName": "apmc" ,"responseVal": "taluka", "responseName": "Taluka" },
      { "responseType": "select", roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"], "fieldName": "apmc" , "responseVal": "apmcName", "responseName": "APMC" }
    ],
    "resubmissionResponse":[
      { "responseType": "select", roles: ["SEC"], "fieldName":"apmc" , "responseVal": "district" , "responseName": "District" },
      { "responseType": "select", roles: ["SEC"], "fieldName":"apmc" , "responseVal": "taluka" , "responseName": "Taluka" },
      { "responseType": "select", roles: ["SEC"], "fieldName":"apmc" , "responseVal": "apmcName" , "responseName": "APMC" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "",
    "fieldVal": "સ્થાપનાનું વર્ષ ( establishment)",
    "fieldName":"copyOfMarketCommitteEstDet",
    "fieldLabel":"Copy Of Market Committe EstDet",
    "responseType": "input", 
    "response": [
      { "responseType": "button", roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"], "fieldName":"copyOfMarketCommitteEstDet","responseVal": "copyOfMarketCommitteEstDet", "responseName": "Copy Of Market Committe Establishment Details" }
    ],
     "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName":"copyOfMarketCommitteEstDet" , "responseVal": "copyOfMarketCommitteEstDet" , "responseName": "Copy Of Market Committe Establishment Details" },
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "",
    "fieldVal": "વર્ગ( Category )",
    "fieldName":"certOfMarketCommitteCategory",
    "fieldLabel":"Cert Of Market Committe Category",
    "response": [
      { "responseType": "select", roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"], "fieldName": "certOfMarketCommitteCategory", "responseVal": "MarketCommitteCategory" ,"responseName": "Market Committe Category"  },
      { "responseType": "button", roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"], "fieldName":"certOfMarketCommitteCategory" , "responseVal": "certOfMarketCommitteCategory" , "responseName": "Certificate Of Market Committe Category" }
    ],
    "resubmissionResponse":[
       { "responseType": "select", roles: ["SEC"], "fieldName": "certOfMarketCommitteCategory", "responseVal": "MarketCommitteCategory" ,"responseName": "Market Committe Category"  },
      { "responseType": "file", roles: ["SEC"], "fieldName":"certOfMarketCommitteCategory" , "responseVal": "certOfMarketCommitteCategory" , "responseName": "Certificate Of Market Committe Category" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "02.",
    "fieldVal": "આ યોજના હેઠળ કયા કયા હેતુઓ માટે સહાય મેળવવા અરજી કરેલ છે ? (Under this scheme, for which purposes has assistance been requested?)",
    "fieldName": "purposeOfAssistance",
    "fieldLabel": "Purpose Of Assistance",
    "responseType": "select",
    "response": [
      // { "responseType": "select", roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"], "fieldName": "purposeOfAssistance", "responseVal": "scheme" ,"responseName": "Scheme"  },
      { "responseType": "selectyard", roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"], "fieldName": "purposeOfAssistance", "responseVal": "purpose","responseName": "Purpose"  }
    ],
    "resubmissionResponse":[
      { "responseType": "select", roles: ["SEC"], "fieldName": "purposeOfAssistance", "responseVal": "scheme" ,"responseName": "Scheme"  },
      { "responseType": "selectyard", roles: ["SEC"], "fieldName": "purposeOfAssistance", "responseVal": "purpose","responseName": "Purpose"  }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "03.",
    "fieldVal": "આ હેતુઓ માટેની પ્રોજેકટ કિંમત કેટલી છે?(પ્લાન અને એસ્ટીમેઇટ) અસલમાં બીડવા. Estimated project cost for these purposes (Layout plan and estimate to be submitted with original documents).",
    "fieldName":"estimateProjectCost",
    "fieldLabel":"Estimate Project Cost",
    "responseType": "button",
    "response": [
            { "responseType": "purposeinput", roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"], "fieldName":"estimateProjectCost" ,"responseVal": "estimateProjectCostAmount", "responseName": "Estimate Project Cost" },
      { "responseType": "button", roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"], "fieldName":"estimateProjectCost" ,"responseVal": "planProjectCost", "responseName": "Plan Project Cost" }

    ],
    "resubmissionResponse":[
      { "responseType": "purposeinput", roles: ["SEC"], "fieldName":"estimateProjectCost" ,"responseVal": "estimateProjectCostAmount", "responseName": "Estimate Project Cost" },
      { "responseType": "file", roles: ["SEC"], "fieldName":"estimateProjectCost" ,"responseVal": "planProjectCost", "responseName": "Plan Project Cost" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "04.",
    "fieldVal": "પ્રોજેકટ કિંમતના કેટલા ટકા મુજબ સહાય મળવાપાત્ર છે ?  (What percentage of the project cost is eligible for assistance? )",
    "fieldName": "percentOfProjCostEligible",
    "fieldLabel": "Percent Of Proj Cost Eligible",
    "responseType": "input",
    "response": [
      { "responseType": "percentage", roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"], "responseVal": "percentOfProjCostEligible","responseName": "Percent Of Project Cost Eligible", "fieldName": "percentOfProjCostEligible" }
    ],
    "resubmissionResponse":[
      { "responseType": "percentage", roles: ["SEC"], "responseVal": "percentOfProjCostEligible","responseName": "Percent Of Project Cost Eligible", "fieldName": "percentOfProjCostEligible" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "",
    "fieldVal": "અરજીમાં દર્શાવેલ હેતુ માટે અગાઉ સહાય લીધેલ છે કે કેમ ?(Has assistance been availed previously for the purpose mentioned in the application?)",
    "fieldName":"isExistingConstructionOnProjSite",
    "fieldLabel":"Is Existing Construction OnProjSite",
    "responseType": "radio",
    "response": [
      { "responseType": "radio", roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"], "fieldName":"isExistingConstructionOnProjSite", "responseVal": "isExistingConstructionOnProjSite" , "responseName": "Is Existing Construction On Project Site" }
    ],
    "resubmissionResponse":[
      { "responseType": "radio", roles: ["SEC"], "fieldName":"isExistingConstructionOnProjSite", "responseVal": "isExistingConstructionOnProjSite" , "responseName": "Is Existing Construction On Project Site" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "05.",
    "fieldVal": "પ્લાન અને અંદાજો માન્ય પેનલ પરના એન્જીનીયરે તૈયાર કરેલા અને જે વર્ષે અરજી કરી હોય તે વર્ષના અથવા અદ્યતન એસ.ઓ.આર. મુજબના અસલમાં રજૂ કરેલ છે? (Are the plans and estimates prepared by an approved panel engineer and submitted in original as per the applicable or updated S.O.R. of the year of application?)",
    "fieldName": "planEstimateByApprovedPE" ,
    "fieldLabel": "Plan Estimate By ApprovedPE" ,
    "responseType": "button",
    "response": [
      { "responseType": "button", roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"], "fieldName": "planEstimateByApprovedPE" ,"responseVal": "planEstimateByApprovedPE" , "responseName": "Plan Estimate By Approved PE"}
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName": "planEstimateByApprovedPE" ,"responseVal": "planEstimateByApprovedPE" , "responseName": "Plan Estimate By Approved PE"}
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "06.",
    "fieldVal": "પ્લાન/એસ્ટીમેટમાં દર્શાવેલ સુચિત કામોનો સમાવેશ પ્લાનમાં થયેલ છે કે કેમ ? જે તે જગ્યા ઉપર અન્ય કોઇ બાંધકામ થયેલ છે કે કેમ ?તથા પ્લાનમાં દર્શાવેલ જગ્યા ઉપર અન્ય કોઇ બાંધકામ થયેલ છે કે કેમ ?તેની રૂબરૂ સ્થળ તપાસ કરી / કરાવી વિગતો આપવી.(Have the proposed works shown in the plan/estimate been included in the plan?Has any other construction been done at the concerned location?And has any other construction been carried out on the area shown in the plan?Provide details after on-site inspection has been done.)",
    "fieldName":"estimatePlanConstruction",
    "fieldLabel":"Estimate Plan Construction",
    "response": [
     
      { "responseType": "button",roles: ["SEC","COM", "Dr","JC", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"], "fieldName":"estimatePlanConstruction", "responseVal": "estimatePlanConstruction" , "responseName": "Estimate Plan Construction" }
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName":"estimatePlanConstruction", "responseVal": "estimatePlanConstruction" , "responseName": "Estimate Plan Construction" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "07.",
    "fieldVal": "સાધનો કે ઓજારો ખરીદવાના હોય તો તેના અસલ ક્વોટેશન રજૂ કરેલ છે ?(If tools or equipment are to be purchased, have the original quotations been submitted?)",
    "fieldName": "toolsEquipQuotations",
    "fieldLabel": "Tools Equip Quotations",
    "responseType": "button",
    "response": [
      { "responseType": "button", roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],  "fieldName": "toolsEquipQuotations" ,"responseVal": "toolsEquipQuotations" , "responseName": "Tools Equip Quotations" }
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"],  "fieldName": "toolsEquipQuotations" ,"responseVal": "toolsEquipQuotations" , "responseName": "Tools Equip Quotations" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "08.",
    "fieldVal": "અંદાજો જાહેર બાંધકામ ખાતાના માન્ય એસ.ઓ.આર. મુજબના છે તે અંગેનું સરકારશ્રીનું સંબંધિત ઈજનેરશ્રીનું પ્રમાણપત્ર સામેલ રાખેલ છે ?(Is the certificate from the concerned government engineer included, confirming that the estimates are as per the approved S.O.R. of the public works department?)",
    "fieldName": "estimateCertifiedByGovtEngineer",
    "fieldLabel": "Estimate Certified By Govt Engineer",
    "responseType": "button",
    "response": [
      { "responseType": "button", roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"], "fieldName": "estimateCertifiedByGovtEngineer", "responseVal": "estimateCertifiedByGovtEngineer" , "responseName": "Estimate Certified By Govt Engineer"  }
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName": "estimateCertifiedByGovtEngineer", "responseVal": "estimateCertifiedByGovtEngineer" , "responseName": "Estimate Certified By Govt Engineer"  }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  }
]

export const formFieldDataP2 = [
  {
    "fieldNo": "01",
    "fieldVal": "બજાર સમિતિમાં બાંધકામ કરવા માટે સંબંધિત સક્ષમ સત્તાધિકારીની મેળવેલ મંજૂરીની નકલ બીડેલ છે ?અથવા સક્ષમ સત્તાધિકારીની મંજૂરી મેળવી બાંધકામ કરવામાં આવશે, તેવી લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a copy of the approval from the competent authority for construction in the Market Committee been attached? Or has a written undertaking been submitted stating that approval will be obtained before commencing construction?)",
    "fieldName":"permissionFromAuthority" ,
    "fieldLabel":"Permission From Authority" ,
    "responseType": "button",
    "response": [
      { "responseType": "button", "fieldName":"permissionFromAuthority" , "responseVal": "permissionFromAuthority", "responseName": "Permission From Authority" }
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName":"permissionFromAuthority" , "responseVal": "permissionFromAuthority", "responseName": "Permission From Authority" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "02",
    "fieldVal": "સહાયના અનુસંધાને કરેલ બાંધકામ અંગેનો વીમો લેવામાં આવશે, તેવી સંબંધિત બજાર સમિતિએ લેખિત બાંહેધરી રજૂ કરેલ છે? (Has the concerned Market Committee submitted a written undertaking that insurance will be taken for the construction done under the assistance?)",
    "fieldName":"insuranceUndertakingPostConstruction",
    "fieldLabel":"Insurance Undertaking Post Construction",
    "responseType": "button",
    "response": [
      { "responseType": "button", "fieldName":"insuranceUndertakingPostConstruction" , "responseVal": "insuranceUndertakingPostConstruction", "responseName": "Insurance Undertaking Post Construction" }
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName":"insuranceUndertakingPostConstruction" , "responseVal": "insuranceUndertakingPostConstruction", "responseName": "Insurance Undertaking Post Construction" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "03",
    "fieldVal": "સહાય મેળવ્યા બાદ હિસાબોનું ઓડીટ સહકારી ખાતાના ઓડીટર મારફતે કરાવવામાં આવશે, તેવી સંબંધિત બજાર સમિતિએ લેખિત બાંહેધરી રજૂ કરેલ છે? (Has the Market Committee submitted a written undertaking that accounts will be audited by the Cooperative Department Auditor after receiving assistance?)",
    "fieldName":"auditUndertakingAfterAssistance" ,
    "fieldlabel":"Audit Undertaking After Assistance" ,
    "responseType": "button",
    "response": [
      { "responseType": "button", "fieldName":"auditUndertakingAfterAssistance" , "responseVal": "auditUndertakingAfterAssistance", "responseName": "Audit Undertaking After Assistance" }
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName":"auditUndertakingAfterAssistance" , "responseVal": "auditUndertakingAfterAssistance", "responseName": "Audit Undertaking After Assistance" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "04",
    "fieldVal": "4.આયોજનાની તમામ શરતોનું પાલન કરવામાં આવશે, તેવી લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted that all terms and conditions of the scheme will be complied with?)",
    "fieldName":"schemeConditionsUndertaking",
    "fieldLabel":"Scheme Conditions Undertaking",
    "responseType": "button",
    "response": [
      { "responseType": "button", "fieldName":"schemeConditionsUndertaking" , "responseVal": "schemeConditionsUndertaking" ,"responseName": "Scheme Conditions Undertaking"}
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName":"schemeConditionsUndertaking" , "responseVal": "schemeConditionsUndertaking" ,"responseName": "Scheme Conditions Undertaking"}
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "05",
    "fieldVal": "મંજૂર થયેલ સહાયની રકમ બજાર સમિતિ અને જે તે જિલ્લાના નાયબ નિયામક ખેતબજાર અને ગ્રામ્ય અર્થતંત્ર તથા જિલ્લા રજિસ્ટ્રાર, સહકારી સંસ્થાઓના સંયુક્ત નામે રાષ્ટ્રીયકૃત બેંકમાં જમા કરાશે અને ઉપયોગના પ્રમાણમાં જિલ્લા રજિસ્ટ્રારશ્રીની મંજૂરીથી ઉપાડ કરવામાં આવશે, તેવી લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted that the approved grant amount will be deposited in a nationalized bank jointly in the name of the Market Committee and the concerned Deputy Director and District Registrar, and that withdrawal will be made with the approval of the District Registrar as per the utilization?)",

    // "fieldVal":"જે હેતુ માટે સહાયની માંગણી કરવામાં આવી છે તે હેતુ માટે બજાર સમિતિ ભવિષ્યમાં અન્ય સહાય આપતી નાણાંકીય સંસ્થા પાસેથી સહાયની રકમ નહીં મેળવે તેવી લેખિત બાંહેધરી સામેલ છે? તેની નકલ (Has a written undertaking been included that the Market Committee will not seek financial assistance for the same purpose from any other funding agency in the future? A copy of the same.)",
    "fieldName":"jointAccountAssistanceUndertaking",
     "fieldLabel":"Joint Account Assistance Undertaking",
    responseType: "button",
    "response": [
      { "responseType": "button", "fieldName":"jointAccountAssistanceUndertaking" , "responseVal": "jointAccountAssistanceUndertaking","responseName": "Joint Account Assistance Undertaking" }
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName":"jointAccountAssistanceUndertaking" , "responseVal": "jointAccountAssistanceUndertaking","responseName": "Joint Account Assistance Undertaking" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "06",
    "fieldVal":"જે હેતુ માટે સહાયની માંગણી કરવામાં આવી છે તે હેતુ માટે બજાર સમિતિ ભવિષ્યમાં અન્ય સહાય આપતી નાણાંકીય સંસ્થા પાસેથી સહાયની રકમ નહીં મેળવે તેવી લેખિત બાંહેધરી સામેલ છે? તેની નકલ (Has a written undertaking been included that the Market Committee will not seek financial assistance for the same purpose from any other funding agency in the future? A copy of the same.)",

    // "fieldVal":"નિયામકશ્રી, ખેત બજાર અને ગ્રામ્ય અર્થતંત્ર, ગાંધીનગર સુચવે તે પ્રકારના રજિસ્ટરો નિભાવવાના રહેશે અને જરૂર જણાય તેવી માહિતી જ્યારે માંગે ત્યારે પુરી પાડવાની રહેશે, તે અંગેની લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted stating that registers as suggested by the Director, Agricultural Market and Rural Economy, Gandhinagar will be maintained, and necessary information will be provided as and when required?)",
    "fieldName":"noPriorAssistanceUndertaking",
    "fieldLabel":"No Prior Assistance Undertaking",
    "responseType": "button",
    "response": [
      { "responseType": "button", "fieldName":"noPriorAssistanceUndertaking" , "responseVal": "noPriorAssistanceUndertaking", "responseName": "No Prior Assistance Undertaking" }
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName":"noPriorAssistanceUndertaking" , "responseVal": "noPriorAssistanceUndertaking", "responseName": "No Prior Assistance Undertaking" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "07",
    "fieldVal":"નિયામકશ્રી, ખેત બજાર અને ગ્રામ્ય અર્થતંત્ર, ગાંધીનગર સુચવે તે પ્રકારના રજિસ્ટરો નિભાવવાના રહેશે અને જરૂર જણાય તેવી માહિતી જ્યારે માંગે ત્યારે પુરી પાડવાની રહેશે, તે અંગેની લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted stating that registers as suggested by the Director, Agricultural Market and Rural Economy, Gandhinagar will be maintained, and necessary information will be provided as and when required?)",

    // "fieldVal": "આ યોજનાની કોઇપણ શરતનો ભંગ થયેલ જણાય તો સહાયની રકમ વ્યાજ સહિત પરત લેવા સરકારશ્રી હકકદાર રહેશે, તે અંગેની લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted stating that in case of any violation of the scheme conditions, the Government shall be entitled to recover the assistance amount with interest?)",
    "fieldName":"registerMaintenanceUndertaking" ,
    "fieldLabel":"Register Maintenance Undertaking" ,
    responseType: "button",
    "response": [
      { "responseType": "button", "fieldName":"registerMaintenanceUndertaking" , "responseVal": "registerMaintenanceUndertaking", "responseName": "Register Maintenance Undertaking" }
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName":"registerMaintenanceUndertaking" , "responseVal": "registerMaintenanceUndertaking", "responseName": "Register Maintenance Undertaking" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "08",
    "fieldVal": "આ યોજનાની કોઇપણ શરતનો ભંગ થયેલ જણાય તો સહાયની રકમ વ્યાજ સહિત પરત લેવા સરકારશ્રી હકકદાર રહેશે, તે અંગેની લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted stating that in case of any violation of the scheme conditions, the Government shall be entitled to recover the assistance amount with interest?)",

    // "fieldVal": "બજાર સમિતિએ વિકાસના કામ માટે સહાય મળ્યા બાદ બે વર્ષની અંદર કામ પૂરૂં કરવાનું રહેશે, તે અંગે તથા સહાયની રકમ વપરાશના પ્રમાણપત્ર માટે માન્ય પેનલ પરના એન્જીનીયરની સહી સાથે પ્રમાણપત્ર રજૂ કરવાનું રહેશે, તે અંગેની લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted that the development work will be completed within two years of receiving assistance, and that a certificate with the signature of a certified panel engineer will be submitted confirming the use of the grant?)",
    "fieldName":"repaymentOnViolationUndertaking",
    "fieldLabel":"Repayment On Violation Undertaking",
    responseType: "button",
    "response": [
      { "responseType": "button", "fieldName":"repaymentOnViolationUndertaking" , "responseVal": "repaymentOnViolationUndertaking", "responseName": "Repayment On Violation Undertaking" }
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName":"repaymentOnViolationUndertaking" , "responseVal": "repaymentOnViolationUndertaking", "responseName": "Repayment On Violation Undertaking" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "09",
    "fieldVal": "બજાર સમિતિએ વિકાસના કામ માટે સહાય મળ્યા બાદ બે વર્ષની અંદર કામ પૂરૂં કરવાનું રહેશે, તે અંગે તથા સહાયની રકમ વપરાશના પ્રમાણપત્ર માટે માન્ય પેનલ પરના એન્જીનીયરની સહી સાથે પ્રમાણપત્ર રજૂ કરવાનું રહેશે, તે અંગેની લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted that the development work will be completed within two years of receiving assistance, and that a certificate with the signature of a certified panel engineer will be submitted confirming the use of the grant?)",

    // "fieldVal": "મંજૂર થયેલ સહાયની રકમ બજાર સમિતિ અને જે તે જિલ્લાના નાયબ નિયામક ખેતબજાર અને ગ્રામ્ય અર્થતંત્ર તથા જિલ્લા રજિસ્ટ્રાર, સહકારી સંસ્થાઓના સંયુક્ત નામે રાષ્ટ્રીયકૃત બેંકમાં જમા કરાશે અને ઉપયોગના પ્રમાણમાં જિલ્લા રજિસ્ટ્રારશ્રીની મંજૂરીથી ઉપાડ કરવામાં આવશે, તેવી લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted that the approved grant amount will be deposited in a nationalized bank jointly in the name of the Market Committee and the concerned Deputy Director and District Registrar, and that withdrawal will be made with the approval of the District Registrar as per the utilization?)",
    "fieldName":"constructionCompletionCertificate" ,
    "fieldLabel":"Construction Completion Certificate" ,
    "responseType": "button",
    "response": [
      { "responseType": "button", "fieldName":"constructionCompletionCertificate" , "responseVal": "constructionCompletionCertificate", "responseName": "Construction Completion Certificate" }
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName":"constructionCompletionCertificate" , "responseVal": "constructionCompletionCertificate", "responseName": "Construction Completion Certificate" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "10",
    "fieldVal": "બજાર સમિતિ પાસે સરકારશ્રીનું કે કોઇ સંસ્થાનું મુદતવીતી લેણું બાકી નથી, તેવી લેખિત બાંહેધરી રજૂ કરેલ છે? (Has a written undertaking been submitted stating that there is no overdue loan from the Government or any other institution pending against the Market Committee?)",
    "fieldName":"noOutstandingDuesUndertaking" ,
    "fieldLabel":"No Outstanding Dues Undertaking" ,
    "responseType": "button",
    "response": [
      { "responseType": "button", "fieldName":"noOutstandingDuesUndertaking" , "responseVal": "noOutstandingDuesUndertaking" ,"responseName": "No Outstanding Dues Undertaking"}
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName":"noOutstandingDuesUndertaking" , "responseVal": "noOutstandingDuesUndertaking" ,"responseName": "No Outstanding Dues Undertaking"}
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "11",
    "fieldVal": 'સહાય અન્વયે બાંધકામ કરવાનું હોય તો ઉદ્યોગ અને ખાણ વિભાગના ઠરાવ ક્રમાંક SPO-102005-1407-ચ, તા. 22/11/06 તથા સંબંધિત જોગવાઈઓ અનુસાર "ઈ-ટેન્ડરીંગ" કરાશે અને તેની સૂચનાઓનું પાલન કરાશે, તેવી લેખિત બાંહેધરી રજૂ કરેલ છે? (If construction is to be undertaken under the grant, has a written undertaking been submitted stating that "e-Tendering" will be done as per Industries and Mines Department Resolution No. SPO-102005-1407-Ch, dated 22/11/06 and relevant provisions, and that its instructions will be followed?)',
    "fieldName":"constructionProcurementETendering" , 
    "fieldLabel":"Construction Procurement ETendering" , 
    "responseType": "button",
    "response": [
      { "responseType": "button", "fieldName":"constructionProcurementETendering" , "responseVal": "constructionProcurementETendering", "responseName": "Construction Procurement E Tendering" }
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName":"constructionProcurementETendering" , "responseVal": "constructionProcurementETendering", "responseName": "Construction Procurement E Tendering" }
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "12",
    "fieldVal": 'મંજૂર થયેલ સહાયના અનુસંધાનમાં જો કોઈ વસ્તુ ખરીદવાની હોય, તો તે ખરીદી સરકારશ્રીના અમલમાં રહેલા નિયમો અને ધોરણો અનુસાર "ઈ-ટેન્ડરીંગ" દ્વારા કરાશે, તેવી લેખિત બાંહેધરી રજૂ કરેલ છે? (If any item is to be purchased under the approved assistance, has a written undertaking been submitted stating that the purchase will be made through "e-Tendering" as per the prevailing rules and guidelines of the Government?)',
    "fieldName":"goodsProcurementETendering" ,
    "fieldLabel":"Goods Procurement ETendering" ,
    "responseType": "button",
    "response": [
      { "responseType": "button", "fieldName":"goodsProcurementETendering" , "responseVal": "goodsProcurementETendering", responseName: "Goods Procurement E-Tendering"}
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName":"goodsProcurementETendering" , "responseVal": "goodsProcurementETendering", responseName: "Goods Procurement E-Tendering"}
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  },
  {
    "fieldNo": "13",
    "fieldVal": 'જે હેતુ માટે સહાય મંજુર થશે તે હેતુ માટે જ ઉપયોગ કરવામાં આવશે તેવી બાંહેધરી. (A guarantee that the assistance will be used solely for the approved purpose.)',
    "fieldName":"guaranteeAssistance" ,
    "fieldLabel":"Guarantee Assistance" ,
    "responseType": "button",
    "response": [
      { "responseType": "button", "fieldName":"guaranteeAssistance" , "responseVal": "guaranteeAssistance", responseName: "Guarantee Assistance"}
    ],
    "resubmissionResponse":[
      { "responseType": "file", roles: ["SEC"], "fieldName":"guaranteeAssistance" , "responseVal": "guaranteeAssistance", responseName: "Guarantee Assistance"}
    ],
    "action": { "verify": "", "update": "", "comment": "" }
  }
];

export const formFieldDataP3 = [
  {
    fieldNo: "10.",
    roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],
    fieldVal: "જે હેતુ માટે સહાયની માંગણી કરવામાં આવી છે તે હેતુ માટે બજાર સમિતિની માલીકીની જમીન છે ? હા, તો તે અંગેના દસ્તાવેજોની નકલ સામેલ રાખેલ છે ?(Does the Market Committee own the land for the purpose for which assistance is requested? If yes, is a copy of the related documents attached?)",
    fieldName: "isLandOwnedByMarketingCommitee", 
    fieldLabel: "Is Land Owned By Marketing Commitee", 
    responseType: "button",
    response: [{ 
      responseType: "button", 
      roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],  
      fieldName: "isLandOwnedByMarketingCommitee", 
      responseVal: "isLandOwnedByMarketingCommitee",
      responseName: "Is Land Owned By Marketing Commitee"
    }],
    resubmissionResponse: [{ 
      responseType: "file", 
      roles: ["SEC"],  
      fieldName: "isLandOwnedByMarketingCommitee", 
      responseVal: "isLandOwnedByMarketingCommitee",
      responseName: "Is Land Owned By Marketing Commitee"
    }],
    action: { verify: "", update: "", comment: "" }
  },
  {
    fieldNo: "11.",
    roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],
    fieldVal: "આ યોજના હેઠળ અગાઉ સહાય મંજૂર થયેલ છે? ( Has assistance been approved earlier under this scheme? )",
    fieldName: "hasAssistanceApproved",
    fieldLabel: "Has Assistance Approved",
    responseType: "radio",
    response: [{ 
      responseType: "radio", 
      roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],  
      fieldName: "hasAssistanceApproved",  
      responseVal: "isApproved",
      responseName: "Has Assistance Approved" 
    }],
    resubmissionResponse: [{ 
      responseType: "radio", 
      roles: ["SEC"],  
      fieldName: "hasAssistanceApproved",  
      responseVal: "isApproved",
      responseName: "Has Assistance Approved" 
    }],
    action: { verify: "", update: "", comment: "" }
  },
  {
    fieldNo: "12.",
    roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],
    fieldVal: "બજાર સમિતિ સામાન્ય વિસ્તાર કે આદિજાતિ વિસ્તારમાં આવેલી છે? તે અંગેનું પ્રમાણપત્ર સામેલ રાખવું.(Is the Market Committee located in a general area or a tribal area? Attach the relevant certificate.)",
    fieldName: "isMarktingCommitteeLocatedInGeneral",
    fieldLabel: "Is Markting Committee Located In General",
    responseType: "radio",
    response: [
      { 
        responseType: "radio", 
        roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],  
        fieldName: "isMarktingCommitteeLocatedInGeneral", 
        responseVal: "isApproved",
        responseName: "Is Markting Committee Located In General" 
      },
      { 
        responseType: "button", 
        roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],  
        fieldName: "isMarktingCommitteeLocatedInGeneral", 
        responseVal: "marktingCommitteeLocatedInGeneral",
        responseName: "Markting Committee Located In General"
      }
    ],
    resubmissionResponse: [
      { 
        responseType: "radio", 
        roles: ["SEC"],  
        fieldName: "isMarktingCommitteeLocatedInGeneral", 
        responseVal: "isApproved",
        responseName: "Is Markting Committee Located In General" 
      },
      { 
        responseType: "file", 
        roles: ["SEC"],  
        fieldName: "isMarktingCommitteeLocatedInGeneral", 
        responseVal: "marktingCommitteeLocatedInGeneral",
        responseName: "Markting Committee Located In General"
      }
    ],
    action: { verify: "", update: "", comment: "" }
  },
  {
    fieldNo: "13.",
    roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],
    fieldVal: "પ્રોજેકટ પૂર્ણ કરવા સહાય ઉપરાંતની રકમનો ખર્ચ કરવા માટે બજાર સમિતિ સક્ષમ છે ? તે ખર્ચ બજાર સમિતિ કેવી રીતે મેળવશે, તે અંગેની વિગતો રજૂ કરેલ છે ?(Is the Market Committee capable of bearing the cost beyond the assistance amount to complete the project? Have the details of how the committee will manage this expense been submitted?)",
    fieldName: "isMarktingCommFinanciallyCapableOfExpense",
    fieldLabel: "Is Markting Comm Financially Capable Of Expense",
    responseType: "radio",
    response: [
    
      { 
        responseType: "button", 
        roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],  
        fieldName: "isMarktingCommFinanciallyCapableOfExpense", 
        responseVal: "marktingCommFinanciallyCapableOfExpense", 
        responseName: "Markting Comm Financially Capable Of Expense" 
      }
    ],
    resubmissionResponse: [
   
      { 
        responseType: "file", 
        roles: ["SEC"],  
        fieldName: "isMarktingCommFinanciallyCapableOfExpense", 
        responseVal: "marktingCommFinanciallyCapableOfExpense", 
        responseName: "Markting Comm Financially Capable Of Expense" 
      }
    ],
    action: { verify: "", update: "", comment: "" }
  },
  {
    fieldNo: "14.",
    roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],
    fieldVal: "છેલા ત્રણ વર્ષના આવક, ખર્ચ અને બચતની વિગત દર્શાવતું પત્રક રજૂ કરેલ છે?(Has a statement showing income, expenditure, and savings for the last three years been submitted?)",
    fieldName: "incExpenditureForLast3Yrs", 
    fieldLabel: "Inc Expenditure For Last 3 Yrs",
    responseType: "button",
    response: [{ 
      responseType: "button", 
      roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],  
      fieldName: "incExpenditureForLast3Yrs", 
      responseVal: "incExpenditureForLast3Yrs",
      responseName: "Inc Expenditure For Last 3 Yrs" 
    }],
    resubmissionResponse: [{ 
      responseType: "file", 
      roles: ["SEC"],  
      fieldName: "incExpenditureForLast3Yrs", 
      responseVal: "incExpenditureForLast3Yrs",
      responseName: "Inc Expenditure For Last 3 Yrs" 
    }],
    action: { verify: "", update: "", comment: "" }
  },
  {
    fieldNo: "15.",
    roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],
    fieldVal: "છેલા ત્રણ વર્ષના આવક-જાવકના સરવૈયાની ઓડીટેડ પ્રમાણિત નકલ રજૂ કરેલ છે ?(Has a certified audited copy of the income-expenditure summary for the last three years been submitted?)",
    fieldName: "auditIncExpenditureForLast3Yrs",
    fieldLabel: "Audit Inc Expenditure For Last 3 Yrs",
    responseType: "button",
    response: [{ 
      responseType: "button", 
      roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],  
      fieldName: "auditIncExpenditureForLast3Yrs", 
      responseVal: "auditIncExpenditureForLast3Yrs", 
      responseName: "Audit Inc Expenditure For Last 3 Yrs" 
    }],
    resubmissionResponse: [{ 
      responseType: "file", 
      roles: ["SEC"],  
      fieldName: "auditIncExpenditureForLast3Yrs", 
      responseVal: "auditIncExpenditureForLast3Yrs", 
      responseName: "Audit Inc Expenditure For Last 3 Yrs" 
    }],
    action: { verify: "", update: "", comment: "" }
  },
  {
    fieldNo: "16.",
    roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],
    fieldVal: "બજાર સમિતિ પાસે ખેડૂતલક્ષી કઇ કઇ સુવિધાઓ હાલ ઉપલબ્ધ છે. તેનું પત્રક રજૂ કરેલ છે ?(Which farmer-oriented facilities are currently available with the Market Committee? Has the list been submitted?)",
    fieldName: "existingFarmerFacilities",
    fieldLabel: "Existing Farmer Facilities",
    responseType: "button",
    response: [{ 
      responseType: "button", 
      roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],  
      fieldName: "existingFarmerFacilities", 
      responseVal: "existingFarmerFacilities", 
      responseName: "Existing Farmer Facilities" 
    }],
    resubmissionResponse: [{ 
      responseType: "file", 
      roles: ["SEC"],  
      fieldName: "existingFarmerFacilities", 
      responseVal: "existingFarmerFacilities", 
      responseName: "Existing Farmer Facilities" 
    }],
    action: { verify: "", update: "", comment: "" }
  },
  {
    fieldNo: "17.",
    roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],
    fieldVal: "છેલા પાંચ વર્ષમાં નિયંત્રણમાં લીધેલ જણસીઓની માર્કેટ શેષ ફીની વિગત દર્શાવતું પત્રક તથા આગામી પાંચ વર્ષમાં માર્કેટ શેષ ફીની થનાર આવકની વિગત દર્શાવતું પત્રક રજૂ કરેલ છે ?(Has a statement been submitted showing the market cess income from controlled commodities over the past five years and the projected income from market cess for the next five years?)",
    fieldName: "marketCessIncome5YrsLast",
    fieldLabel: "Market Cess Income 5 Yrs Last", 
    responseType: "button",
    response: [
      { 
        responseType: "button",
        roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],  
        fieldName: "marketCessIncome5YrsLast", 
        responseVal: "marketCessIncome5YrsLast", 
        responseName: "Market Cess Income 5 Yrs Last" 
      },
      { 
        responseType: "button", 
        roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],
        fieldName: "marketCessIncome5YrsLast", 
        responseVal: "marketCessIncome5YrsNext", 
        responseName: "Market Cess Income 5 Yrs Next" 
      }
    ],
    resubmissionResponse: [
      { 
        responseType: "file",
        roles: ["SEC"],  
        fieldName: "marketCessIncome5YrsLast", 
        responseVal: "marketCessIncome5YrsLast", 
        responseName: "Market Cess Income 5 Yrs Last" 
      },
      { 
        responseType: "file", 
        roles: ["SEC"],
        fieldName: "marketCessIncome5YrsLast", 
        responseVal: "marketCessIncome5YrsNext", 
        responseName: "Market Cess Income 5 Yrs Next" 
      }
    ],
    action: { verify: "", update: "", comment: "" }
  },
  {
    fieldNo: "18.",
    roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],
    fieldVal: "આ યોજના હેઠળ સહાય લેવા માટે બજાર સમિતિની મળેલ સામાન્ય સભાના ઠરાવની નકલ.(Copy of the Market Committee's General Body resolution regarding availing assistance under this scheme.)",
    fieldName: "availingAssistance", 
    fieldLabel: "Availing Assistance", 
    responseType: "button",
    response: [
   
      { 
        responseType: "button",
        roles: ["SEC","COM", "Dr", "SC", "DY","JC","DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"], 
        fieldName: "availingAssistance", 
        responseVal: "availingAssistance", 
        responseName: "Availing Assistance" 
      }
    ],
    resubmissionResponse: [
      { 
        responseType: "file",
        roles: ["SEC"], 
        fieldName: "availingAssistance", 
        responseVal: "availingAssistance", 
        responseName: "Availing Assistance" 
      }
    ],
    action: { verify: "", update: "", comment: "" }
  },
  // {
  //   fieldNo: "19.",
  //   roles: ["SEC","JC","COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],
  //   fieldVal: "નાયબ નિયામક ખેતબજાર અને ગ્રામ્ય અર્થતંત્ર અને જિલ્લા રજિસ્ટ્રાર, સ.મં. નો સહાય મંજુર કરવા બાબતનો વિગતવાર અભિપ્રાય.(Detailed opinion of the Deputy Director, Agricultural Market and Rural Economy, and District Registrar, Co-op. Societies regarding the sanction of assistance.)",
  //   fieldName: "Sanction Assistance",
  //   fieldLabel: "Sanction Assistance",
  //   responseType: "button",
  //   response: [
  //     { 
  //       responseType: "file",
  //       roles: ["JC"],  
  //       fieldName: "sanctionAssistance", 
  //       responseVal: "sanctionAssistance", 
  //       responseName: "Sanction Assistance" 
  //     },
  //     { 
  //       responseType: "button",
  //       roles: ["COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],  
  //       fieldName: "sanctionAssistance", 
  //       responseVal: "sanctionAssistance", 
  //       responseName: "Sanction Assistance" 
  //     },
  //   ],
  //   resubmissionResponse: [
  //     { 
  //       responseType: "file",
  //       roles: ["SEC"],  
  //       fieldName: "sanctionAssistance", 
  //       responseVal: "sanctionAssistance", 
  //       responseName: "Sanction Assistance" 
  //     }
  //   ],
  //   action: { verify: "", update: "", comment: "" }
  // },
  // {
  //   fieldNo: "",
  //   actionNo: "20",
  //   roles: ["COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],
  //   fieldVal: "જેમણે સ્થળ તપાસ કરી છે તે પ્રતિનિધિનો હોદ્દો (designation of representative who has done inspected on-site)",
  //   fieldName: "Designation Representative", 
  //   fieldLabel: "Designation Representative",
  //   responseType: "input",
  //   response: [
  //     { 
  //       responseType: "edInput",
  //       roles: ["COM"],  
  //       fieldName: "designationRepresentative", 
  //       responseVal: "designationRepresentative", 
  //       responseName: "Designation Representative" 
  //     },
  //     { 
  //       responseType: "input",
  //       roles: [ "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],  
  //       fieldName: "designationRepresentative", 
  //       responseVal: "designationRepresentative", 
  //       responseName: "Designation Representative" 
  //     },
  //   ],
  //   resubmissionResponse: [
  //     { 
  //       responseType: "input",
  //       roles: ["SEC"],  
  //       fieldName: "designationRepresentative", 
  //       responseVal: "designationRepresentative", 
  //       responseName: "Designation Representative" 
  //     }
  //   ],
  //   action: { verify: "", update: "", comment: "" }
  // },
  // {
  //   fieldNo: "",
  //   actionNo: "21",
  //   roles: ["COM", "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],
  //   fieldVal: "જેમણે સ્થળ તપાસ કરી છે તે પ્રતિનિધિનું નામ (name of representative who has done inspected on-site)",
  //   fieldName: "Name Repres",
  //   fieldLabel: "Name Of Representative who has done Inspected on-site" ,
  //   responseType: "input",
  //   response: [
  //     { 
  //       responseType: "edInput",
  //       roles: ["COM"],  
  //       fieldName: "nameRepres", 
  //       responseVal: "nameRepres", 
  //       responseName: "Name of Representative" 
  //     },
  //     { 
  //       responseType: "input",
  //       roles: [ "Dr", "SC", "DY", "DT", "Tr", "Per", "SA", "HJC", "HJR", "HOS", "GCA"],  
  //       fieldName: "nameRepres", 
  //       responseVal: "nameRepres", 
  //       responseName: "Name of Representative" 
  //     },
  //   ],
  //   resubmissionResponse: [
  //     { 
  //       responseType: "input",
  //       roles: ["SEC"],  
  //       fieldName: "nameRepres", 
  //       responseVal: "nameRepres", 
  //       responseName: "Name of Representative" 
  //     }
  //   ],
  //   action: { verify: "", update: "", comment: "" }
  // },
];


